import * as actionTypes from '../actions/actionTypes';
import { updateObject } from "../utility";

const initialState = {
  regLoading: null,
  regError: null,
  token: null,
  error: null,
  loading: null
};

const regStart = (state, action) => {
  return updateObject(state, {regLoading: true});
}

const regSuccess = (state, action) => {
  return updateObject(state, {regError: null, regLoading: false});
}

const regFail = (state, action) => {
  return updateObject(state, {regError: action.regError, regLoading: false});
}

const authStart = (state, action) => {
  return updateObject(state, {error: null, loading: true});
}

const authSucess = (state, action) => {
  // console.log('token: ', action.idToken);
  return updateObject(state, {token: action.idToken, error: null, loading: false});
}

const authFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
}

const authLogout = (state, action) => {
  return updateObject(state, {token: null});
}

const reducer = (state  = initialState, action) => {

  switch (action.type) {
    case actionTypes.REG_START: return regStart(state, action);
    case actionTypes.REG_SUCCESS: return regSuccess(state, action);
    case actionTypes.REG_FAIL: return regFail(state, action);
    case actionTypes.AUTH_START: return authStart(state, action);
    case actionTypes.AUTH_SUCCESS: return authSucess(state, action);
    case actionTypes.AUTH_FAIL: return authFail(state, action);
    case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
    default:
      return state;
  }

}

export default reducer;